'use client';

import { IconUserFilled } from '@zillow/constellation-icons/react/filled/icon-user-filled';
import { forwardRef, useContext } from 'react';

import { cx } from '@/styled-system/css';

import { Icon } from '../icon/icon';
import { AvatarRootContext } from './context/avatar-root.context';
import { avatarIconRecipe } from './styles/avatar-icon.styles';
import type { AvatarIconPropsInterface } from './types/avatar-icon.types';

/**
 * @since 10.0.0
 */
export const AvatarIcon = forwardRef<SVGSVGElement, AvatarIconPropsInterface>(
  (props, forwardedRef) => {
    const { children = <IconUserFilled />, css: cssProp, ...rest } = props;

    const { size, tone } = useContext(AvatarRootContext);

    return (
      <Icon
        ref={forwardedRef}
        data-c11n-component="Avatar.Icon"
        data-c11n-version={__C11N_VERSION__}
        css={{ ...avatarIconRecipe.raw({ tone, size }), ...cssProp }}
        {...rest}
        className={cx('c11n_avatar__icon', rest.className)}
      >
        {children}
      </Icon>
    );
  },
);

AvatarIcon.displayName = 'Avatar.Icon';
